import { react2panel } from 'common/util/react2panel';
import { TimeQueryBlock } from './time-query-block';
export const TimeQueryBlockEl = react2panel("mp-time-query-block", TimeQueryBlock);